//====== WR data 24/09/2026 — SmartFlow Importer: etapa de Pré-requisitos via BBP (Business
// Blueprint). Camada de dados — mesmo padrão de itemImporterApi.js/importerApi.js, rotas em
// /api/smartflow-importer/bbp/* (backend).
//======
import api from "services/api"

const BASE = "/smartflow-importer"

/**
 * Sobe o .docx do BBP e devolve a sugestão da IA (Depósitos/Grupos de Item/Grupos de PN) + o HTML
 * renderizado do documento inteiro (pra consulta na tela). As LISTAS só viram dado definitivo do
 * projeto depois de `salvarPreRequisitos` (validação do usuário) — mas o upload em si (arquivo +
 * quem/quando enviou) já fica registrado no backend nesta chamada.
 * @param {string} projectId
 * @param {File} arquivo
 * @param {string} enviadoPor e-mail do usuário logado, pra registro de autoria do upload
 */
export async function processarBbp(projectId, arquivo, enviadoPor) {
  const formData = new FormData()
  formData.append("file", arquivo)
  if (enviadoPor) formData.append("enviadoPor", enviadoPor)

  const { data } = await api.post(`${BASE}/bbp/${projectId}/processar`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 90000, // extração do docx + IA pode levar mais que o padrão da instância `api`
  })
  return data
}

/** Lê os pré-requisitos já validados/salvos do projeto (vazio se nunca foi preenchido). */
export async function lerPreRequisitos(projectId) {
  const { data } = await api.get(`${BASE}/bbp/${projectId}/pre-requisitos`)
  return data
}

/**
 * Grava a validação final do usuário — sempre as 3 listas COMPLETAS (o componente manda tudo,
 * inclusive o que não mudou desde a sugestão da IA). NÃO manda bbpOriginalFileName/bbpHtml/
 * bbpGcsOriginalPath de volta — já foram gravados no upload (`processarBbp`) e reenviá-los aqui
 * (o bbpHtml de um BBP com imagens facilmente passa de 100kb) estourava o limite do body-parser do
 * backend e fazia o salvar falhar silenciosamente (WR data 30/09/2026).
 * @param {string} projectId
 * @param {Object} preRequisitos { depositos, gruposItem, gruposPn, validadoPor }
 */
export async function salvarPreRequisitos(projectId, preRequisitos) {
  const { data } = await api.post(`${BASE}/bbp/${projectId}/pre-requisitos`, preRequisitos)
  return data
}

//====== WR data 25/09/2026 — baixa o .docx ORIGINAL salvo no GCS (não o HTML de consulta que já
// vem embutido em bbpHtml) — precisa passar pela instância `api` (não um <a href> direto) porque a
// rota exige Authorization; mesmo padrão de download por blob já usado em ProjectDriveFiles.js.
export async function baixarBbpOriginal(projectId, nomeArquivo) {
  const { data } = await api.get(`${BASE}/bbp/${projectId}/original`, { responseType: "blob" })
  const url = window.URL.createObjectURL(data)
  const link = document.createElement("a")
  link.href = url
  link.setAttribute("download", nomeArquivo || "BBP.docx")
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

//====== WR data 25/09/2026 — exclui o BBP do projeto (arquivo no GCS + reseta as listas/validação
// no Mongo, tudo do lado do backend) — pedido do usuário: permitir excluir, não só subir.
export async function excluirBbp(projectId) {
  const { data } = await api.delete(`${BASE}/bbp/${projectId}`)
  return data
}
